import Select from "@/common/components/Select";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ClientUserData } from "@/common/types/client/user.type";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";
import { useClientUsers } from "@/features/users/hooks/useClientUsers";

const DashboardFilterBuyerHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: usersOptions,
  } = useClientUsers({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ClientUserData>({
      labelFieldName: 'full_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <Select
      label="Selecione o autor"
      markAsRequired
      options={usersOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterBuyerHiddenFilter;
